import React, { useCallback } from 'react';

import { Box } from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNew';
import { Save } from '@mui/icons-material';

import { Button, useSaveContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';

const FormWizardActions = ({
  next,
  isLastPage,
  previous,
  isFirstPage,
  edit,
}: {
  next: () => void;
  isLastPage: boolean;
  previous: () => void;
  isFirstPage: boolean;
  edit: boolean;
}) => {
  const { save } = useSaveContext();
  const { getValues, trigger } = useFormContext();

  const onSubmit = useCallback(async () => {
    const isValid = await trigger();
    if (!isValid || !save) return;

    const data = getValues();
    save(data);
  }, [save, getValues, trigger]);

  const onNext = useCallback(async () => {
    const isValid = await trigger();
    if (!isValid) return;
    next();
  }, [next, trigger]);

  if (!save) return null;

  if (!isLastPage) {
    return (
      <Box display="flex" justifyContent="space-between" width="100%">
        <Button startIcon={<ArrowBackIcon />} disabled={isFirstPage} onClick={previous} label="Previous" />
        <Button variant="contained" onClick={onNext} label="Next" />
      </Box>
    );
  }
  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      {edit && <Button startIcon={<ArrowBackIcon />} disabled={isFirstPage} onClick={previous} label="Previous" />}
      {edit && <Button startIcon={<Save />} variant="contained" label="Save" onClick={onSubmit} />}
    </Box>
  );
};

export default FormWizardActions;
